import { StoreApiData } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreInfo/type"
import { transformTimeRange } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreInfo/utils/utils"
import { TransformedStoreItem } from "../types"

export const transformStoreData = (apiData: StoreApiData[]): TransformedStoreItem[] => {
    return apiData.map((item) => {
        const { attributes } = item
        const openingHours = transformTimeRange(attributes.timeRange || [])

        return {
            id: item.id,
            localizationIds: item.localizationIds,
            name: attributes.name,
            address: attributes.address,
            guidance: attributes.guidance || undefined,
            email: attributes.email,
            phone: attributes.phone,
            latitude: attributes.latitude,
            longitude: attributes.longitude,
            googleMapCode: attributes.googleMapCode || undefined,
            openingHours: openingHours.length > 0 ? openingHours : undefined,
            description: attributes.description || undefined,
        }
    })
}

/**
 * storeId lưu trong Puck thuộc locale lúc editor chọn, còn store đang render thuộc locale của URL.
 * Strapi i18n cấp id khác nhau cho mỗi bản dịch nên phải khớp qua cả localizationIds.
 */
export const matchesStoreId = (store: TransformedStoreItem, storeId: number) =>
    store.id === storeId || (store.localizationIds?.includes(storeId) ?? false)
